// Razansy — leichtes Verhalten
(function(){
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.style.opacity = 1; en.target.style.transform='none'; io.unobserve(en.target); }
      });
    }, {threshold:.12});
    document.querySelectorAll('.value,.cat,.editorial-inner,.philosophy h2').forEach(function(el){
      el.style.opacity = 0; el.style.transform='translateY(20px)';
      el.style.transition='opacity .9s cubic-bezier(.2,.7,.2,1), transform .9s cubic-bezier(.2,.7,.2,1)';
      io.observe(el);
    });
  }
})();
